import axios from 'axios'
import qs from 'qs'
import { commonParams, headers, baseUrl } from './config'
import store from '../store'
/* eslint-disable */
let request = axios.create({
  baseURL: baseUrl,
  params: commonParams,
  data: commonParams,
  headers: headers,
  transformRequest: [function (data) {
    // 对 data 进行转换处理
    return qs.stringify(data)
  }]
})

// 添加响应拦截器
request.interceptors.response.use((response) => {
  return response
}, (error) => {
  console.dir(error)
  // console.log(error.response.status)
  if (error && error.response) {
    let code = error.response.data.code || error.response.status
    let msg = error.response.data.msg || error.response.statusText
    if (code === '401' || code === 401) {
      store.commit('SET_NEED_LOGIN', true)
      return Promise.reject({ code: 401, msg: msg })
    }
    store.commit('SET_STATUS', { code, msg })
  }
  return Promise.reject(error)
})
export default request



// WEBPACK FOOTER //
// ./src/api/request.js